import { Component, Vue } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'

import { actions, getters, modules } from '../store'

function getMapping(type: string): string[] {
  const functionNames: string[] = []

  if (type === 'getters') {
    if (typeof getters === 'object') {
      Object.keys(getters).forEach((key) => {
        if (typeof (getters as any)[key] === 'function') {
          functionNames.push(key)
        }
      })
    }
  }

  if (type === 'actions') {
    if(typeof actions === 'object'){
      Object.keys(actions).forEach((key) => {
        if (typeof (actions as any)[key] === 'function') {
          functionNames.push(key)
        }
      })
    }
  }

  if(typeof modules === 'object'){
    Object.values(modules).forEach((module) => {
      if (typeof module === 'object' && module?.getters) {
        Object.keys((module as any)?.[type]).forEach((key) => {
          if (typeof (module as any)?.[type][key] === 'function') {
            functionNames.push(key)
          }
        })
      }
    })
  }

  return functionNames
}

//Global computed and methods
@Component({
  //Store getters
  computed: mapGetters(getMapping('getters')),
  //Store actions
  methods: {
    ...mapActions(getMapping('actions'))
  }
})
export default class Utils extends Vue { }